import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { ContentControlStudioLiveViewModelV2 } from "../../content-control-studio-live-view-model-v2";

@Component({
  selector: "evrideo-content-control-studio-live-header",
  templateUrl: "./content-control-studio-live-header.component.html",
  styleUrl: "./content-control-studio-live-header.component.scss",

})
export class ContentControlStudioLiveHeaderComponent implements OnInit, OnDestroy {
  readonly placeholder = "--:--:--.---";

  @Input() title: string;
  @Input() vm!: ContentControlStudioLiveViewModelV2;

  private _tickId: ReturnType<typeof setInterval> | null = null;

  public videoTimeUtcMs: number = 0;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._tickId = setInterval(() => {
      this.videoTimeUtcMs = this.vm.hlsVideoSource.currentVideoTimeUtcMs;
      this.cd.markForCheck();
    }, 200);
  }

  ngOnDestroy(): void {
    if (this._tickId) {
      clearInterval(this._tickId);
      this._tickId = null;
    }
  }
}
